import { alpha } from '@mui/material';
import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  mealDrawer: {
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'flex-end',
      backgroundColor: alpha(theme.palette.cinnamon.main, 0.5),
    },
  },

  mainConatiner: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.whitePepper.main,
    overflow: 'hidden',
  },

  mealDrawerHeaderConatiner: {
    width: '500px',
    padding: '25px 35px 20px 25px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    zIndex: 10,
  },

  contentWrapper: {
    width: '500px',
    flexGrow: 1,
    overflowY: 'auto',
    /* width */
    '&::-webkit-scrollbar': {
      width: '6px',
    },

    /* Track */
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.turmeric.main,
      borderRadius: '4px',
    },
  },

  dishWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    rowGap: '8px',
  },

  dish: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  mealWrapper: {
    // minHeight: '100vh',
    //padding: '20px 27px 200px 45px',
    padding: '0px 0px 120px',
  },

  mealContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    columnGap: '30px',
    rowGap: '60px',
  },

  contentShow: {
    padding: '50px 25px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: theme.palette.whitePepper.main,
  },

  seeFullMenuWrapper: {
    margin: '45px 0 30px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  seeFullMenuBtnWrapper: {
    textTransform: 'none',
    borderRadius: '55px',
    borderColor: theme.palette.cinnamon.main,
    width: '425px',
    height: '75px',
    '&:hover': {
      backgroundColor: theme.palette.whitePepper.main,
      borderColor: theme.palette.cinnamon.main,
    },
  },

  notSureWrapper: {
    marginTop: '85px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  dishImageBox: {
    width: '120px',
    height: '120px',
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      width: '160px',
      height: '160px',
    },
    [theme.breakpoints.up('xl')]: {
      width: '220px',
      height: '220px',
    },
  },

  bottomWrapper: {
    position: 'fixed',
    bottom: '0',
    backgroundColor: theme.palette.whitePepper.main,
  },

  checkoutBtnWrapper: {
    zIndex: 10,
    padding: '15px 38px',
    width: '500px',
    height: '115px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    //boxShadow: '0px -4px 10px rgba(0, 0, 0, 0.15)',
  },
});
